import { useStationLocationList } from "./useStationLocationList";
import { LocationListService } from "./UseCaseLocationSelectionStep";

/**
 * True when the flow's station list loaded successfully and is empty — every
 * station of this use case is closed (e.g. winter hibernation). Loading and
 * failure are NOT "no station": a failure must never look like an absence.
 *
 * One definition for every surface that asks: the home tile's "Aktuell
 * geschlossen" pill, the booking flow's closed screen and the pages that hide
 * their step title and "Weiter" around it. They share one cache entry with the
 * flow's own location query, so asking costs no extra request.
 */
export const useNoBookableStation = (service: LocationListService): boolean => {
  const { data, isSuccess } = useStationLocationList(service);
  return isSuccess && Array.isArray(data) && data.length === 0;
};
